import axios from '@/utils/api'
import FileSaver from 'file-saver'

const actions = {

  async filtrarPorStatus ({ commit }, filtro) {
    const data = await axios({
      method: 'POST',
      url: 'contagem-conversas/filtro-status',
      data: {
        ...filtro
      }
    })
    return data
  },

  async filtrarPorStatusTotal ({ commit }, filtro) {
    const data = await axios({
      method: 'POST',
      url: 'contagem-conversas/filtro-status-total',
      data: {
        ...filtro
      }
    })
    return data
  },

  async filtrarPorPeriodo ({ commit }, filtro) {
    const data = await axios({
      method: 'POST',
      url: 'contagem-conversas/filtro-periodo',
      data: {
        ...filtro
      }
    })
    return data
  },

  async filtrarPorAssunto ({ commit }, filtro) {
    const data = await axios({
      method: 'POST',
      url: 'contagem-conversas/filtro-assunto',
      data: {
        ...filtro
      }
    })
    return data
  },

  async filtrarPorResponsavel ({ commit }, filtro) {
    const data = await axios({
      method: 'POST',
      url: 'contagem-conversas/filtro-responsavel',
      data: {
        ...filtro
      }
    })
    return data
  },

  async listarConversas ({ commit }, filtro) {
    const data = await axios({
      method: 'POST',
      url: 'contagem-conversas/lista-conversas',
      data: {
        ...filtro
      }
    })
    return data
  },

  async findResponsaveis () {
    const data = await axios({
      method: 'GET',
      url: 'usuario-ouvidoria/getByPerfil/OUVIDORIA'
    })
    return data
  },

  // Rota para exportar CSV e começar o download
  async exportarCsvStatus ({ commit }, filtro) {
    const file = await axios({
      method: 'POST',
      url: 'contagem-conversas/csv/status',
      responseType: 'blob',
      data: {
        ...filtro
      }
    })

    const dataRelatorio = new Date()
    FileSaver.saveAs(
      file, `Conversa_Status_${dataRelatorio.toLocaleDateString()}
      ${dataRelatorio.toLocaleTimeString()}.csv`
    )
  },

  async exportarCsvPeriodoMensal ({ commit }, filtro) {
    const file = await axios({
      method: 'POST',
      url: 'contagem-conversas/csv/periodo/mensal',
      responseType: 'blob',
      data: {
        ...filtro
      }
    })

    const dataRelatorio = new Date()
    FileSaver.saveAs(
      file, `Conversa_Periodo_Mensal_${dataRelatorio.toLocaleDateString()}
      ${dataRelatorio.toLocaleTimeString()}.csv`
    )
  },

  async exportarCsvPeriodoSemanal ({ commit }, filtro) {
    const file = await axios({
      method: 'POST',
      url: 'contagem-conversas/csv/periodo/semanal',
      responseType: 'blob',
      data: {
        ...filtro
      }
    })

    const dataRelatorio = new Date()
    FileSaver.saveAs(
      file, `Conversa_Periodo_Semanal_${dataRelatorio.toLocaleDateString()}
      ${dataRelatorio.toLocaleTimeString()}.csv`
    )
  },

  async exportarCsvPeriodoDiario ({ commit }, filtro) {
    const file = await axios({
      method: 'POST',
      url: 'contagem-conversas/csv/periodo/diario',
      responseType: 'blob',
      data: {
        ...filtro
      }
    })
    const dataRelatorio = new Date()
    FileSaver.saveAs(
      file, `Consulta_Periodo_Diario_${dataRelatorio.toLocaleDateString()}
      ${dataRelatorio.toLocaleTimeString()}.csv`
    )
  },
  async exportarCsvListagemConversas ({ commit }, filtro) {
    const file = await axios({
      method: 'POST',
      url: 'contagem-conversas/csv/listagem',
      responseType: 'blob',
      data: {
        ...filtro
      }
    })
    const dataRelatorio = new Date()
    FileSaver.saveAs(
      file, `Listagem_Conversas_${dataRelatorio.toLocaleDateString()}
      ${dataRelatorio.toLocaleTimeString()}.csv`
    )
  },
  async exportarCsvAssunto ({ commit }, filtro) {
    const file = await axios({
      method: 'POST',
      url: 'contagem-conversas/csv/assunto',
      responseType: 'blob',
      data: {
        ...filtro
      }
    })

    const dataRelatorio = new Date()
    FileSaver.saveAs(
      file, `Conversa_Assunto_${dataRelatorio.toLocaleDateString()}
      ${dataRelatorio.toLocaleTimeString()}.csv`
    )
  },
  async exportarCsvResponsavel ({ commit }, filtro) {
    const file = await axios({
      method: 'POST',
      url: 'contagem-conversas/csv/responsavel',
      responseType: 'blob',
      data: {
        ...filtro
      }
    })

    const dataRelatorio = new Date()
    FileSaver.saveAs(
      file, `Conversa_Responsavel_${dataRelatorio.toLocaleDateString()}
      ${dataRelatorio.toLocaleTimeString()}.csv`
    )
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/relatorios_ouvidoria/filtros.js